module.exports = __webpack_public_path__ + "static/media/cognitiveclass_ai_logo.0c6891eb.png";